import { createContext, useContext, useEffect, useState } from "react";
import { getStoredAuth, setStoredAuth, registerUser, loginUser, fetchMe } from "@/lib/apiClient";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(() => getStoredAuth());
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;
    const stored = getStoredAuth();
    if (stored?.token) {
      fetchMe()
        .then((me) => {
          if (active) setAuth((a) => ({ ...a, ...me, token: stored.token }));
        })
        .catch(() => {
          if (active) {
            setStoredAuth(null);
            setAuth(null);
          }
        })
        .finally(() => active && setReady(true));
    } else {
      setReady(true);
    }
    return () => {
      active = false;
    };
  }, []);

  const persist = (data) => {
    const next = { token: data.token, email: data.email, name: data.name, role: data.role };
    setStoredAuth(next);
    setAuth(next);
    return next;
  };

  const login = async (email, password) => persist(await loginUser(email, password));
  const register = async (email, password, name) => persist(await registerUser(email, password, name));
  const logout = () => {
    setStoredAuth(null);
    setAuth(null);
  };

  return (
    <AuthContext.Provider value={{ auth, ready, login, register, logout, isAuthed: !!auth?.token }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
